export const sabolFirebaseConfig = {
    apiKey: 'AIzaSyChRSlS-e5MSG8vSViO-a9bf_pUnKgf61U',
    authDomain: 'sabol-12772.firebaseapp.com',
    databaseURL: 'https://sabol-12772.firebaseio.com',
    projectId: 'sabol-12772',
    storageBucket: 'sabol-12772.appspot.com',
    messagingSenderId: '708530983608',
};
